import React, { useMemo, useState } from 'react';
import {
  Button, Card, Col, Form, Row,
} from 'react-bootstrap';
import { status as PS } from '../../../helpers/passport';
import { floatRenderer } from '../../../services/formatSvc';
import { FloatFlexibleInput } from '../../common/MonetaryFloatInput';
import { parseIsApprovedText } from '../../../helpers/report';

export default function ExpertDecisionCard({
                                             className, proj, onEdit, readOnly, canEdit, onExpertsDecision, cardTitle,
                                           }) {
  const [isApproved, setIsApproved] = useState(true);
  const [recommendations, setRecommendations] = useState('');
  const [protocol, setProtocol] = useState('');
  const [mark, setMark] = useState(0);
  const [isPolicy, setIsPolicy] = useState(false);

  useMemo(() => {
    setRecommendations(proj.expertGroupDecision);
    setProtocol(proj.expertGroupProtocol);
    setMark(proj.expertGroupMark);
    setIsPolicy(proj.strategy?.type === 'policy' || proj.strategy?.num === 'СЦ10');
  }, [proj]);

  const handleIsApprovedChange = (value) => {
    setIsApproved(value);
  };

  const handleRecommendationsChange = ({ target }) => {
    setRecommendations(target.value);
  };

  const handleProtocolChange = ({ target }) => {
    setProtocol(target.value);
  };

  const handleMarkChange = (value) => {
    setMark(value ?? 0);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    onExpertsDecision({
      isApproved, recommendations, protocol, mark,
    });
  };

  const CanEdit = canEdit && ![PS.closed, PS.moved].includes(proj.status);

  return (
    <Card className={className}>
      <Card.Header as={Card.Title} className="p-4">
        {cardTitle || 'Решение экспертной группы'}
      </Card.Header>
      <Card.Body className="p-4">
        { !CanEdit
          && (
          <>
            <Row className="mb-4">
              <Col md={3}>
                <Card.Subtitle className="mb-2 text-muted">Решение</Card.Subtitle>
                <Card.Text>{parseIsApprovedText(proj.status)}</Card.Text>
              </Col>
              <Col md={3}>
                <Card.Subtitle className="mb-2 text-muted">Оценка</Card.Subtitle>
                <Card.Text>{floatRenderer(proj.expertGroupMark)}</Card.Text>
              </Col>
              <Col md={6}>
                <Card.Subtitle className="mb-2 text-muted">Реквизиты протокола</Card.Subtitle>
                <Card.Text>{proj.expertGroupProtocol}</Card.Text>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Card.Subtitle className="mb-2 text-muted">Рекомендации</Card.Subtitle>
                <Card.Text style={{ whiteSpace: 'pre-wrap' }}>{proj.expertGroupDecision}</Card.Text>
              </Col>
            </Row>
          </>
          )}
        { CanEdit
          && (
          <>
            <Row className="mb-4">
              {readOnly && (
                <Col md={6}>
                  <Card.Subtitle className="mb-2 text-muted">Решение</Card.Subtitle>
                  <Card.Text>{parseIsApprovedText(proj.status)}</Card.Text>
                </Col>
              )}
              {!readOnly && (
                <Form.Group as={Col} md="12">
                  <Form.Check onChange={() => handleIsApprovedChange(true)} checked={isApproved} type="radio" id="radio-expert-approved" label={`Одобрено на ${isPolicy ? 'ЦК' : 'ЭГ'}`} inline />
                  <Form.Check onChange={() => handleIsApprovedChange(false)} checked={!isApproved} type="radio" id="radio-expert-not-approved" label={`Не одобрено на ${isPolicy ? 'ЦК' : 'ЭГ'}`} inline />
                </Form.Group>
              )}
            </Row>
            <Row className="mb-4">
              <Form.Group as={Col} md="12">
                <Form.Label>Рекомендации</Form.Label>
                <Form.Control
                  as="textarea"
                  readOnly={!CanEdit}
                  value={recommendations}
                  onChange={handleRecommendationsChange}
                />
              </Form.Group>
            </Row>

            <Row className="mb-4">
              <Form.Group as={Col} md="8">
                <Form.Label>Реквизиты протокола</Form.Label>
                <Form.Control
                  readOnly={!CanEdit}
                  value={protocol}
                  onChange={handleProtocolChange}
                />
              </Form.Group>
            </Row>
            <Row className="mb-4">
              <Form.Group as={Col} md="8">
                <Form.Label>Оценка проекта (от 1 до 10, в т.ч. с округлением до десятых)</Form.Label>
                <FloatFlexibleInput
                  disabled={!CanEdit}
                  value={mark}
                  thousandSeparator=" "
                  decimalScale={1}
                  placeholder="Укажите число от 0 до 10"
                  readOnly={!CanEdit}
                  onChange={handleMarkChange}
                  isAllowed={(values) => {
                    const { formattedValue, floatValue } = values;
                    return formattedValue === '' || (floatValue >= 0 && floatValue <= 10);
                  }}
                />
              </Form.Group>
            </Row>
            <Button as={Col} variant="outline-primary" onClick={handleSubmit}>{!readOnly ? 'Сохранить решение' : 'Сохранить рекомендации/реквизиты протокола'}</Button>
          </>
          )}
      </Card.Body>
    </Card>
  );
}
